// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"p4-z","colorTextValue":"q4-z","swatches":"r4-z","collapseLink":"s4-z","isCollapsed":"t4-z","dropdown":"u4-z","disabled":"v4-z"};